import { useState } from "react";
import styles from "./SeventhScreen.module.css";
import FAQItem from "../components/questions/Questions";
import Buttonb from "../components/button copy/Button";

const SeventhScreen = () => {
  return (
    <>
      <div className={styles.title}>ורגע לפני שנדבר..</div>

      <div className={styles.description}>
        ריכזתי עבורכם את כל השאלות שאולי צצו לכם במהלך הבירורים ואני בטוח שמעניינות אתכם.  
        (לחצו על כל שאלה כדי לפתוח את התשובה)
      </div>

      <FAQItem
        question="איך אני יכול לדעת שתהיה התאמה בינינו מבחינת הטעם?"
        answer={
          "זו באמת אחת השאלות שהכי חשוב לשאול. עיצוב זה לא 'מה יפה בעיניי' , אלא מה מרגיש נכון לכם. אני לומד אתכם קודם - את הסגנון שלכם, את המטרות שלכם, את איך שאתם אוהבים לחיות ומה שחשוב לכם. אנחנו מדברים, עוברים על השראות, בונים יחד כיוון. ובשביל השקט שלכם - הכל מגובה בהדמיה מדויקת, כדי שתוכלו ממש לראות איך זה הולך להיראות לפני שמתחילים."
        }
      />

      <FAQItem
        question="כבר עבדנו עם אדריכל ומעצב בעבר והחוויה לא הייתה טובה... איך נדע שזה לא יקרה שוב?"
        answer={
          "לצערי אני שומע את זה לא מעט. זה מבאס, ואני מבין את החשש. ואני אשמח לשמוע מכם יותר על החווויה הלא נעימה שעברתם,  אחרי למעלה מ-200 בתים שעיצבתי וליוויתי אני תמיד שם דגש על שקיפות אתכם לאורך כל התהליך ועל דרך עבודה מאוד ברורה: תכניות מדויקות, כתב כמויות, תקציב מסודר, הדמיות.. אין כאן אלתורים. המטרה שלי היא שתהיו רגועים ומרוצים לאורך כל הדרך בידיעה שהבית שלכם בידים טובות, לא שתחזרו על חוויה לא נעימה."
        }
      />

      <FAQItem
        question="מה באמת החיסכון פה? זה נשמע כמו עוד הוצאה..."
        answer={
          "זו שאלה לגמרי לגיטימית. אבל ברוב המקרים, דווקא כשחושבים שחוסכים - משלמים ביוקר. אני רואה את זה שוב ושוב: טעויות קטנות בתכנון, ספקים פחות מדויקים, בלת\"מים או שינויים של הרגע האחרון - כל אחת מהן יכולה לעלות אלפי שקלים ובמצטבר להגיע לעשרות אלפי שקלים! כשיש מי שמכוון את כל התהליך - זה פשוט לא קורה. ליווי טוב הוא לא הוצאה - הוא ביטוח, גם לכסף וגם לשפיות שלכם."
        }
      />

      <FAQItem
        question="האם אתה עובד רק עם הספקים שלך?"
        answer={
          "אני עובד עם ספקים שאני מכיר - כאלה שראיתי איך הם עובדים ושטווח המחירים שלהם הכי משתלם עבורכם. זה נותן לי ביטחון ולכם חוסך הפתעות. אבל אם יש לכם ספק שאתם רוצים לעבוד איתו - כמובן שנשב, נבחן ונראה אם זה מתאים. הכי חשוב לי שתרגישו טוב עם מי שמלווה אתכם בדרך."
        }
      />

      <FAQItem
        question="מה קורה אם הקבלן לוחץ עליי לסגור תכניות ואין לי זמן?"
        answer={
          "זה קורה כמעט תמיד. קיבלתם תכניות - והשעון מתחיל לתקתק. הלחץ שם, ואני מכיר את זה מקרוב. בדיוק בשביל זה אני נכנס לתמונה: אני יודע איך להתנהל עם הקבלנים בצורה נכונה גם כשאין הרבה זמן. עובדים לפי שלבים ברורים, בלי בלאגן. אתם לא לבד במירוץ הזה - אני שם אתכם בכל צעד, כדי שלא תרגישו שאתם רצים לבד."
        }
      />
 <Buttonb text="רועי, יש לי עוד שאלה" message="היי רועי הגעתי מהדף שלך, אשמח לשמוע עוד על.."/>
    </>
  );
};

export default SeventhScreen;
